import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer"

export default function Experiments() {

    // Click and scroll
    function handleClick(elementId) {
        const scrollElement = document.getElementById(elementId)
        scrollElement.scrollIntoView({behavior: "smooth"});
        // setTimeout(function () {
        //     scrollElement.scrollIntoView({behavior: "smooth"});
        // }, 100);
        console.log(elementId)
    }

    return (
        <div className="flex flex-col h-lvh">

            {/* Header */}
            <Navbar/>

            {/* Sidebar turns into subheader in mobile device */}
            <div className="inset-x-0 bg-white border-b px-4 sm:px-6 md:px-8 lg:hidden">
                <div className="flex items-center py-4">
                    <button type="button" className="text-gray-500 hover:text-gray-600"
                            data-hs-overlay="#description-sidebar" aria-controls="description-sidebar"
                            aria-label="Toggle navigation">
                        <span className="sr-only">Toggle Navigation</span>
                        <svg className="size-5" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path fillRule="evenodd"
                                  d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"/>
                        </svg>
                    </button>
                    <ol className="ms-3 flex items-center whitespace-nowrap">
                        <li className="flex items-center text-sm text-gray-800">
                            Project
                            <svg
                                className="flex-shrink-0 mx-3 overflow-visible size-2.5 text-gray-400"
                                width="16" height="16" viewBox="0 0 16 16" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M5 1L10.6869 7.16086C10.8637 7.35239 10.8637 7.64761 10.6869 7.83914L5 14"
                                      stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                            </svg>
                        </li>
                        <li className="text-sm font-semibold text-gray-800 truncate">
                            Experiments
                        </li>
                    </ol>
                </div>
            </div>

            {/* Main Content */}
            <div className="lg:flex grow max-w-[85rem] w-full mx-auto">

                {/* Sidebar with accordion */}
                <div id="description-sidebar"
                     className="max-h-svh hs-overlay hs-overlay-open:translate-x-0 -translate-x-full transition-all duration-300 transform hidden fixed top-0 start-0 bottom-0 z-20 w-72 sm:w-[36rem] bg-white border-e border-gray-200 pt-7 overflow-y-auto lg:static lg:block lg:translate-x-0 lg:end-auto lg:bottom-0 ">
                    <div className="px-6">
                        <div className="flex-none text-xl font-semibold px-1">
                            Experiments
                        </div>
                    </div>

                    <nav className="p-6 w-full flex flex-col flex-wrap">
                        <ul className="space-y-1.5">
                            <li>
                                <div onClick={() => handleClick("Experiments-1")}
                                     className="cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-400 rounded-full inline-block"></span>
                                    Expression vector construction & validation
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Experiments-2")}
                                     className="cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-400 rounded-full inline-block"></span>
                                    Protein expression
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Experiments-3")}
                                     className="cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-400 rounded-full inline-block"></span>
                                    Guanine assay
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Experiments-4")}
                                     className="cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-400 rounded-full inline-block"></span>
                                    Reference
                                </div>
                            </li>

                        </ul>
                    </nav>
                </div>

                {/* Major text sections */}
                <div className="max-h-svh overflow-y-auto w-full px-4 sm:px-6 md:px-24 lg:px-32">
                    <div>
                        <div id="Experiments-1" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10">
                            Expression vector construction & validation
                        </div>
                        <div className="text-lg text-gray-800 text-justify mt-5 rounded-2xl leading-relaxed">
                            <div>
                                We constructed the overexpression plasmid with the coding sequences of genes guaA,
                                guaB and aeBlue. GuaA and GuaB were organized into one operon based on their natural
                                relationship, as demonstrated in scientific studies (1). The aeBlue gene encoded for
                                chromoprotein, which was included as a marker for transformation experiments. All
                                sequences were under one T7 inducible expression system, with spacer sequences and
                                ribosome binding sites in between for effective separation and functionality.
                            </div>
                            <div className="mt-5">
                                Following the outcome of the first engineering cycle, we designed an additional
                                knock-down plasmid with a CRISPR-i system targeting gene guaD. This system consisted
                                of two gene cassettes: the dCas9 and the guide RNA (gRNA), each under its own T7
                                regulatory module to ensure distinct expression. The dCas9 gene cassette contained
                                the Streptococcus pyogenes dCas9 sequence (2). The gRNA cassette contained a gRNA
                                scaffold and a sgRNA sequence targeting the coding region of gene guaD on the
                                non-template strand (3). These two cassettes would be activated together with the
                                addition of IPTG. However, this plasmid could not be produced by our provider, and
                                there was insufficient time for a proper revision.
                            </div>
                            <div className="mt-5">
                                The plasmid was assembled through restriction cloning and the insert was added to the
                                pET45 backbone via restriction enzymes SacI and HindIII. Heat shock transformation was
                                used to transform the strain BL21 E. coli with the construct and the outcome was
                                investigated through sequencing. The cultures were plated on CARB+-plates and
                                incubated at 37°C overnight. Culture expansions were performed on 10 of the plated
                                colonies. All cultures were incubated and samples for SDS-PAGE were extracted 2, 5
                                and 16 hours after induction. The construct was also sent for sequencing.
                            </div>
                        </div>
                    </div>
                    <div>
                        <div id="Experiments-2" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10">
                            Protein expression
                        </div>
                        <div className="text-lg text-gray-800 text-justify mt-5 rounded-2xl leading-relaxed">
                            <div>
                                Construct functionality was investigated through SDS-PAGE on the cell-lysate
                                (lysed through sonication). The procedure revealed an overexpression of both genes
                                of interest, guaA and guaB, as thick bands at the corresponding molecular weights
                                were observed on all induced cell lysates. However, no bands could be seen for AeBlue,
                                which coincided with the absence of blue colonies. Thus, the insert sequence was
                                revised by the dry-lab team. It was at this point that an additional construct for
                                the silencing system of the genes guaD and Xdh was designed.
                            </div>
                        </div>
                    </div>
                    <div>
                        <div id="Experiments-3" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10">
                            Guanine assay
                        </div>
                        <div className="text-lg text-gray-800 text-justify mt-5 rounded-2xl leading-relaxed">
                            <div>
                                To measure guanine levels, fluorometric and colorimetric Guanine Assay kits (Cell
                                biolabs) were employed. The induced cultures were sonicated and prepared according to
                                the instructions of the kit. Fluorescence and absorbance were measured for the samples
                                prepared for each kit respectively and compared to standard solutions provided in the
                                package. No conclusive results were observed however, mainly due to faulty standards
                                and possibly also because the assays were made for mammalian cells.
                            </div>
                        </div>
                    </div>
                    <div>
                        <div id="Experiments-4" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10">
                            Reference
                        </div>
                        <div className="text-lg text-gray-800 text-justify mt-6 rounded-2xl leading-relaxed">
                            <ol className="list-decimal space-y-4 pl-5">
                                <li>
                                    Lambden P, Drabble W. The gua Operon of Escherichia coli K-12: Evidence for
                                    Polarity from guaB to guaA. J Bacteriol. 1973;115(3):992-1002. doi:
                                    10.1128/jb.115.3.992-1002.1973.
                                </li>
                                <li>
                                    Qi LS, Larson MH, Gilbert LA, Doudna JA, Weissman JS, Arkin AP, et al.
                                    Repurposing CRISPR as an RNA-guided platform for sequence-specific control of
                                    gene expression. Cell. 2013;152(5):1173-83. doi: 10.1016/j.cell.2013.02.022.
                                </li>
                                <li>
                                    Hawkins JS, Wong S, Peters JM, Almeida R, Qi LS. Targeted transcriptional
                                    repression in bacteria using CRISPR interference (CRISPRi). Methods Mol Biol.
                                    2015;1311:349-62. doi: 10.1007/978-1-4939-2687-9_23.
                                </li>
                            </ol>
                        </div>
                    </div>


                    <div className="h-16"></div>
                </div>
            </div>

            {/* Footer */}
            <Footer />
        </div>
    )
}